// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1OAN8","requiredAsterisk":"Info_requiredAsterisk__3T_4Z"};